import { DebitParams } from 'core/interfaces/DebitParams';
import { endpoints } from 'core/consts/endpoints';
import { getEFTDeduped } from './Common';

const { accounts } = endpoints;

export const getAccounts = (params: DebitParams) => getEFTDeduped(accounts, params);
